import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "main-mine" }
const _hoisted_2 = { class: "user_scanner" }

import { ref } from 'vue'
import { useThemeColor } from '@/utils/theme'
import { showToast, Overlay } from 'vant'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'QRCodeScanner',
  props: {
  pageType: {
    type: Number,
    default: 1 // 1 培训签到 2 我的扫一扫
  },
  isExpired: {
    type: Boolean,
    default: false
  },
  isStart: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

_useCssVars(_ctx => ({
  "38db22f0": (_unref(themeColor))
}))

const { t } = useI18n()
const scanning = ref(false)
const themeColor = useThemeColor()
const qrcodeStream = ref()

const props = __props

const startScan = () => {
  // scanning.value = true
  showToast(t('feature_not_supported'))
}

// 培训扫码签到
const signScan = () => {
  if (props.isExpired) {
    // 签到已过期
    showToast(t('signin_end'))
    return
  }
  if (props.isStart) {
    // 未开始
    showToast(t('signin_not_start'))
    return
  }
  // 暂时禁用
  showToast(t('feature_not_supported'))
  // scanning.value = true
}

const closeScan = () => {
  scanning.value = false
  qrcodeStream.value.stop()
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.pageType === 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "sign_scan_code",
          onClick: signScan
        }, [
          _createVNode(_component_van_icon, { name: "scan" }),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('scan_signin')), 1)
        ]))
      : (_openBlock(), _createElementBlock("i", {
          key: 1,
          class: "iconfont icon-icon_saoma",
          onClick: startScan
        })),
    _createVNode(_unref(Overlay), { show: scanning.value }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("i", {
            class: "iconfont icon-icon_wode_wodepeixun_kejianyulan_guanbi icon_scan",
            onClick: closeScan
          })
        ]),
        _createElementVNode("div", {
          class: "wrapper",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, _cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "block" }, null, -1)
        ])),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('qr_code_scanner')), 1)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})